/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Canonical durable-order status filter exposed by `GET /orders`.  Compatibility aliases remain accepted at the HTTP boundary, but OpenAPI advertises only the six states the `orders` table can actually store.
 */
export enum OrderStatusFilter {

    New = 'new',

    PartiallyFilled = 'partially_filled',

    Filled = 'filled',

    Cancelled = 'cancelled',

    Rejected = 'rejected',

    Expired = 'expired'
}
